package medicalRecord.containers


import com.jingfangpai.api.clients.MedicalRecordApiClient
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.MedicalRecord
import com.jingfangpai.common.orm.mapping.SignSymptom
import medicalRecord.components.MedicalRecords
import react.*
import react.dom.div
import setTitle

external interface MedicalRecordPageProps : RProps {

}

data class MedicalRecordsPageContextData(
    var getMedicalRecordList: (okCallback: (result: ApiResponse<List<MedicalRecord>>) -> Unit, errorCallback:(Throwable)->Unit)->Unit)

val MedicalRecordsPageContext = createContext(MedicalRecordsPageContextData(MedicalRecordApiClient::getList))

val MedicalRecordsPageProvider = functionalComponent<MedicalRecordPageProps> { props ->

    setTitle("验案集")

    fun placeHolderFunction(param: String) {
        console.log("doing something with param")
    }

    useEffectOnce { }

    MedicalRecordsPageContext.Provider(MedicalRecordsPageContextData(MedicalRecordApiClient::getList)) {
        div("MedicalRecordPage-page") {
            child(MedicalRecords) {

            }
        }
    }
}
